{
  "sidebar": {
    "data": {
      "title": "資料"
    },
    "insights": {
      "title": "洞察"
    },
    "instances_caches": {
      "title": "快取"
    },
    "dependencies": {
      "title": "相依元件"
    },
    "jvm": {
      "title": "JVM"
    },
    "logging": {
      "title": "日誌"
    },
    "security": {
      "title": "安全性"
    },
    "web": {
      "title": "Web"
    },
    "custom-link": {
      "title": "連結"
    }
  }
}
